export default __webpack_public_path__ + "static/wood-4af6090972806ee2038e6d86fcde783f.png";